<template>
  <svg class="text-white" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <path d="M14,8A14,14,0,1,0,28,22,14,14,0,0,0,14,8Zm0,5.419a4.968,4.968,0,1,1-4.968,4.968A4.968,4.968,0,0,1,14,13.419Zm0,19.419a10.818,10.818,0,0,1-8.27-3.85,6.294,6.294,0,0,1,5.56-3.376,1.381,1.381,0,0,1,.4.062,7.474,7.474,0,0,0,2.309.39,7.446,7.446,0,0,0,2.309-.39,1.381,1.381,0,0,1,.4-.062,6.294,6.294,0,0,1,5.56,3.376A10.818,10.818,0,0,1,14,32.839Z" transform="translate(0 -8)" class="fill-current"/>
  </svg>
</template>
